import { IAppState } from '../../../AppModulesWrapper';
import { EPublishTermsStatus } from '../../types/reducers/publishTerms';

export function selectPublishTermsStatus(state: IAppState): EPublishTermsStatus {
  const {
    ui: {
      publishTerms: { status },
    },
  } = state.servicePickerWidgetV2;

  return status;
}
